import emailValidator from './emailValidator';

export default emailValidator;
